// Chat feature public API

// Initialize chat widgets on module load
import { registerDefaultChatWidgets } from './components/widgets';
registerDefaultChatWidgets();

// Components
export { ChatInterface } from './components/core/ChatInterface';
export { ChatWorkspace } from './components/workspace/ChatWorkspace';
export { FloatingChatWidget } from './components/widget/FloatingChatWidget';

// Providers
export { ChatProvider, useChatContext, useChatSession, useChatStreaming } from './providers/ChatProvider';

// Hooks for handler integration
export { useChatHandlerResults } from './hooks/useChatHandlerResults';

// Handler registry for other features
export { chatHandlerRegistry } from './services/chatHandlerRegistry';
export type { ChatHandler } from './services/chatHandlerRegistry';

// Types
export type { ChatMessage, ChatSession, MessageContext } from './types/domain';
export type { ChatWorkspaceState } from './types/workspace';
